<template>
    <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="#1973a5" dark>
            <v-card-text>
                Cargando Datos
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<style></style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
    props: ['sendData'],
    data() {
        return {
            dialogLoader: false
        };
    },
    methods: {
        loadInit() {
            Swal.fire({
                title: `¿Estás seguro de eliminar el registro de ${this.sendData.hospital}?`,
                text: "¡Este cambio no se puede revertir!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí',
                cancelButtonText: 'No'
            }).then((result) => {
                if (result.isConfirmed) {
                    console.log("asdasfasf", this.sendData);
                    this.deleteItem();
                } else {
                    this.closeDelete();
                }
            })
        },
        closeDelete() {
            this.$emit("closeDelete");
        },
        deleteItem() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .delete(RUTA_API + "/hospital/" + this.sendData.idHospital + "/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            Swal.fire({
                                title: "¡Éxito!",
                                text: "¡Se eliminó correctamente!",
                                icon: "success",
                            });
                            this.closeDelete();
                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            Swal.fire({
                                title: "¡Error!",
                                text: "No se eliminó. Es posible que haya pacientes registrados en este hospital.",
                                icon: "error",
                                confirmButtonText: "Aceptar",
                            });
                            this.closeDelete();
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
    },
    mounted() { },
    computed: {
    },
    created() {
        this.loadInit();
    },
    components: {
    },
};
</script>